import { useEffect, useState } from "react";
import DashboardFooter from "../../components/Footer";
import { useDispatch } from "react-redux";
import MenteeDashboard from "./MenteeDashboard";
import MentorDashboard from "./MentorDashboard";
import MenteeMentorDashboard from "./MenteeMentorDashboard";
import { fetchProfileInfo } from "../../redux/profileSlice";
import SponsorDashboard from "./SponsorDashboard";
import Loader from "../../components/Loader";

export default function Dashboard() {
  const dispatch = useDispatch();
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Push current state to history
    window.history.pushState(null, null, window.location.href);

    // Handle back button
    const handlePopState = () => {
      window.history.go(1);
    };

    // Add event listener
    window.addEventListener("popstate", handlePopState);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    console.log("inside 1st use effect");
    dispatch(fetchProfileInfo()).then(() => {
      setLoading(false); // Mark profile as fetched when API call completes
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {role === "mentee" && <MenteeDashboard />}
      {role === "mentor" && <MentorDashboard />}
      {role === "mentee_mentor" && <MenteeMentorDashboard />}
      {role === "sponsor" && <SponsorDashboard />}
      <DashboardFooter />
    </>
  );
}
